'use client'

import React from 'react'
import { useTranslation } from 'react-i18next'
import { overseas } from '@/constants'
import { cn } from '@/lib/utils'
import { FeChatType } from '@/types/chat'
import { AgentStudioLogo } from './header/agent-studio-logo'

const LogoCN = (props: { className?: string; onClick?: () => void }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="51"
      height="16"
      viewBox="0 0 51 16"
      fill="none"
      className={props.className}
      onClick={props.onClick}
    >
      <g clipPath="url(#clip0_787_16019)">
        <path
          d="M30.9307 11.3055C30.2348 10.2701 29.6874 9.15556 29.3083 7.99432H33.3182V6.17395H29.1867V2.65627C30.5276 2.53887 31.6931 2.35217 32.6492 2.10182L32.7935 2.06363L32.2348 0.328125L32.1061 0.360657C31.2263 0.579893 30.2999 0.73548 29.3536 0.82176C28.3989 0.909455 27.3197 0.958959 26.1499 0.970275H24.2885V2.77367H26.1485C26.4314 2.77367 26.8472 2.76377 27.3833 2.74397V6.17537H23.7454V0.564334H17.669V6.51624H20.0877V12.6846L19.4724 12.8119V8.00846H17.669V13.1853L17.1089 13.3012L17.4752 15.0665L23.7511 13.7666L23.3847 12.0014L21.8911 12.3112V9.9434H23.8769V8.14001H21.8911V6.51483H23.604V7.99149H27.232C26.8515 9.86278 25.6959 11.7991 23.7963 13.744L23.7496 13.7921C23.5106 14.0353 23.2588 14.28 23 14.5205L22.901 14.6124L24.0806 15.9986L24.1895 15.8981C26.1499 14.082 27.546 12.2404 28.3366 10.4257C29.2956 12.4328 30.6662 14.1584 32.4073 15.553L32.5191 15.6421L33.6379 14.2121L33.5276 14.1244C32.5361 13.3394 31.6634 12.3904 30.9321 11.3013L30.9307 11.3055ZM21.9335 2.36773V4.67749H19.4823V2.36773H21.9335Z"
          fill="var(--content-primary)"
        />
        <path
          d="M7.06647 9.98208C7.06647 10.8039 6.8925 11.6313 6.55021 12.4432C6.2065 13.2565 5.73691 13.9991 5.15275 14.6525L5.06223 14.7544L6.314 15.9651L6.41159 15.8548C7.14427 15.0273 7.72842 14.1009 8.14709 13.1051C8.56859 12.1009 8.78217 11.0514 8.78217 9.98491V6.06836H7.06647V9.98491V9.98208Z"
          fill="var(--content-primary)"
        />
        <path
          d="M13.6464 6.06543H11.9307V15.7627H13.6464V6.06543Z"
          fill="var(--content-primary)"
        />
        <path
          d="M5.314 10.6885C5.42291 10.3278 5.47666 9.95302 5.47666 9.5782C5.47666 8.52869 5.11315 7.40422 4.39603 6.23308L5.52475 1.64892C5.55162 1.54284 5.56435 1.46363 5.56435 1.40422C5.56435 1.20903 5.49504 1.02516 5.35784 0.859668C5.1669 0.627702 4.93069 0.511719 4.65487 0.511719H-5.72205e-06V15.9403H1.82178V12.1369L2.30692 13.4467L2.43847 13.3986C3.95898 12.8469 4.92644 11.936 5.314 10.6913V10.6885ZM1.82178 2.33067H3.51343L2.54172 6.1666C2.52333 6.22459 2.51485 6.29531 2.51485 6.39574C2.51485 6.5881 2.57001 6.77056 2.69023 6.96433C2.89674 7.23591 3.12022 7.64467 3.3338 8.14538C3.54738 8.64892 3.65629 9.14255 3.65629 9.61356C3.65629 9.80026 3.62941 9.99262 3.57849 10.1793C3.35784 10.8399 2.76661 11.3575 1.82178 11.7154V2.33067Z"
          fill="var(--content-primary)"
        />
        <path
          d="M13.7468 3.22675C13.1202 2.42052 12.4639 1.48559 11.7949 0.450226C11.7185 0.301711 11.6153 0.1928 11.4823 0.115006C11.3494 0.0386274 11.2051 -0.000976562 11.0537 -0.000976562H9.68175C9.36491 -0.000976562 9.11456 0.133394 8.9321 0.399306C8.29278 1.39789 7.64073 2.31586 6.99151 3.12632C6.3437 3.93537 5.62941 4.68643 4.86704 5.35687L4.7652 5.44598L5.84723 6.79959L5.95756 6.70907C6.78217 6.03721 7.58415 5.21119 8.33946 4.25645C9.07213 3.33 9.68599 2.48134 10.1627 1.73311H10.5587C12.0651 4.00892 13.454 5.68219 14.6902 6.70907L14.8006 6.79959L15.9052 5.44457L15.7977 5.35546C15.0608 4.74443 14.3706 4.02873 13.7482 3.22675H13.7468Z"
          fill="var(--content-primary)"
        />
        <path
          d="M50.2645 0.845703H48.4385V15.0451H50.2645V0.845703Z"
          fill="var(--content-primary)"
        />
        <path
          d="M42.6124 0.849071H39.8331C39.4031 0.849071 39.0255 1.13903 38.9151 1.55346L35.0764 15.0457H36.9547L38.2235 10.3031L42.7935 9.68358L42.5502 7.88585L38.7327 8.40353L40.471 2.75713C40.4866 2.70197 40.5361 2.66237 40.5941 2.66237H41.8515C41.9095 2.66237 41.9604 2.70197 41.9745 2.75713L45.4908 15.0457H47.3692L43.5304 1.55346C43.4201 1.13761 43.041 0.847656 42.6124 0.847656V0.849071Z"
          fill="var(--content-primary)"
        />
      </g>
      <defs>
        <clipPath id="clip0_787_16019">
          <rect width="50.2659" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}

const LogoEN = (props: { className?: string; onClick?: () => void }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="71"
      height="18"
      viewBox="0 0 71 18"
      fill="none"
      className={props.className}
      onClick={props.onClick}
    >
      <path
        d="M66.4984 4.17288C67.5251 4.17288 68.3704 4.51723 69.034 5.20592C69.7102 5.89462 70.0483 6.84627 70.0483 8.06088V13.8271H67.6253V8.3614C67.6253 7.73532 67.4563 7.25949 67.1182 6.93393C66.7801 6.59584 66.3293 6.4268 65.7658 6.4268C65.1397 6.4268 64.6389 6.62088 64.2632 7.00906C63.8876 7.39723 63.6997 7.97949 63.6997 8.75584V13.8271H61.2768V4.43584H63.6997V5.48766C64.2883 4.61114 65.2211 4.17288 66.4984 4.17288Z"
        fill="var(--content-primary)"
      />
      <path
        d="M56.6347 4.43582H59.0577V13.8271H56.6347V12.7753C56.0462 13.6518 55.1133 14.0901 53.8361 14.0901C52.8093 14.0901 51.9578 13.7457 51.2817 13.057C50.618 12.3683 50.2862 11.4167 50.2862 10.2021V4.43582H52.7091V9.90156C52.7091 10.5276 52.8782 11.0097 53.2163 11.3478C53.5543 11.6734 54.0051 11.8362 54.5686 11.8362C55.1947 11.8362 55.6956 11.6421 56.0712 11.2539C56.4469 10.8657 56.6347 10.2835 56.6347 9.50713V4.43582Z"
        fill="var(--content-primary)"
      />
      <path
        d="M48.6604 3.15863H43.4013V6.27654H48.5102V8.75584H43.4013V13.8271H40.8093V0.679321H48.6604V3.15863Z"
        fill="var(--content-primary)"
      />
      <path
        d="M34.4049 4.17288C35.6696 4.17288 36.7465 4.65497 37.6355 5.61914C38.5371 6.57079 38.9879 7.74158 38.9879 9.13149C38.9879 10.5214 38.5371 11.6984 37.6355 12.6626C36.7465 13.6143 35.6696 14.0901 34.4049 14.0901C33.0901 14.0901 32.0759 13.6331 31.3621 12.719V17.5837H28.9392V4.43584H31.3621V5.54401C32.0759 4.62993 33.0901 4.17288 34.4049 4.17288ZM32.0946 11.0473C32.583 11.5357 33.2028 11.7798 33.9541 11.7798C34.7054 11.7798 35.3252 11.5357 35.8136 11.0473C36.3145 10.5464 36.5649 9.90784 36.5649 9.13149C36.5649 8.35514 36.3145 7.7228 35.8136 7.23445C35.3252 6.73358 34.7054 6.48314 33.9541 6.48314C33.2028 6.48314 32.583 6.73358 32.0946 7.23445C31.6063 7.7228 31.3621 8.35514 31.3621 9.13149C31.3621 9.90784 31.6063 10.5464 32.0946 11.0473Z"
        fill="var(--content-primary)"
      />
      <path
        d="M20.0727 10.127C20.3983 11.304 21.2811 11.8925 22.7211 11.8925C23.6477 11.8925 24.3489 11.5795 24.8247 10.9534L26.7781 12.0804C25.8515 13.4202 24.4867 14.0901 22.6835 14.0901C21.1308 14.0901 19.8849 13.6205 18.9458 12.6814C18.0067 11.7423 17.5371 10.559 17.5371 9.13149C17.5371 7.71653 18.0004 6.53949 18.927 5.60036C19.8536 4.64871 21.0432 4.17288 22.4957 4.17288C23.8731 4.17288 25.0063 4.64871 25.8953 5.60036C26.7969 6.55201 27.2477 7.72906 27.2477 9.13149C27.2477 9.44453 27.2164 9.77636 27.1538 10.127H20.0727ZM20.0352 8.24871H24.8247C24.687 7.6101 24.399 7.13427 23.9607 6.82123C23.535 6.50819 23.0467 6.35166 22.4957 6.35166C21.8446 6.35166 21.3061 6.52071 20.8804 6.8588C20.4547 7.18436 20.1729 7.64766 20.0352 8.24871Z"
        fill="var(--content-primary)"
      />
      <path
        d="M16.6106 6.76488H14.4881V10.6717C14.4881 10.9972 14.5695 11.2351 14.7323 11.3854C14.8951 11.5357 15.133 11.6233 15.4461 11.6484C15.7591 11.6609 16.1473 11.6546 16.6106 11.6296V13.8271C14.9452 14.015 13.7681 13.8584 13.0794 13.3576C12.4033 12.8567 12.0652 11.9614 12.0652 10.6717V6.76488H10.4311V4.43584H12.0652V2.5388L14.4881 1.80627V4.43584H16.6106V6.76488Z"
        fill="var(--content-primary)"
      />
      <path
        d="M5.16522 14.0901C3.86296 14.0901 2.7673 13.8021 1.87826 13.2261C0.989218 12.6376 0.36313 11.8424 0 10.8407L2.21635 9.5447C2.72974 10.8845 3.73774 11.5544 5.24035 11.5544C5.96661 11.5544 6.49878 11.423 6.83687 11.16C7.17496 10.897 7.344 10.5652 7.344 10.1645C7.344 9.70122 7.13739 9.34435 6.72417 9.09392C6.31096 8.83096 5.57217 8.54922 4.50783 8.2487C3.9193 8.07339 3.41844 7.89809 3.00522 7.72279C2.60452 7.54748 2.19757 7.31583 1.78435 7.02783C1.38365 6.72731 1.07687 6.35166 0.864 5.90087C0.65113 5.45009 0.544696 4.92418 0.544696 4.32313C0.544696 3.13357 0.964174 2.18818 1.80313 1.48696C2.65461 0.773221 3.67513 0.416351 4.8647 0.416351C5.92904 0.416351 6.86191 0.679308 7.6633 1.20522C8.47722 1.71861 9.10957 2.43861 9.56035 3.36522L7.38157 4.62366C6.85565 3.4967 6.0167 2.93322 4.8647 2.93322C4.32626 2.93322 3.90052 3.05844 3.58748 3.30887C3.28696 3.54679 3.1367 3.85983 3.1367 4.248C3.1367 4.66122 3.30574 4.99931 3.64383 5.26226C3.99444 5.5127 4.65809 5.78818 5.63478 6.0887C6.03548 6.21392 6.336 6.31409 6.53635 6.38922C6.74922 6.45183 7.03096 6.55826 7.38157 6.70853C7.7447 6.84626 8.02017 6.97774 8.208 7.10296C8.40835 7.22818 8.63374 7.39722 8.88417 7.61009C9.13461 7.82296 9.32243 8.04209 9.44765 8.26748C9.58539 8.49287 9.69809 8.76835 9.78574 9.09392C9.88591 9.40696 9.936 9.75131 9.936 10.127C9.936 11.3416 9.49148 12.3057 8.60243 13.0195C7.72591 13.7332 6.58017 14.0901 5.16522 14.0901Z"
        fill="var(--content-primary)"
      />
    </svg>
  )
}
export const LogoMobile = (props: {
  className?: string
  onClick?: () => void
}) => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={props.className}
      onClick={props.onClick}
    >
      <g id="logo">
        <rect
          x="0.25"
          y="0.25"
          width="31.5"
          height="31.5"
          rx="8.63889"
          fill="white"
        />
        <rect
          x="0.25"
          y="0.25"
          width="31.5"
          height="31.5"
          rx="8.63889"
          stroke="#EBEBEB"
          strokeWidth="0.5"
        />
        <path
          id="Vector"
          d="M24.4066 9.38862C27.317 10.3807 27.4277 10.9288 27.2881 11.473C26.6187 13.8538 10.4867 9.68244 8.11513 24.6801L7.84371 15.1779L10.8319 7.66264C14.1745 4.94191 20.6437 4.52029 24.4066 9.38862Z"
          fill="#005AFF"
        />
        <path
          id="Vector_2"
          d="M10.8648 7.25683C14.749 7.00387 18.0652 8.16726 19.2497 9.13434C19.4763 9.32011 19.4157 9.65345 19.1509 9.77862C14.1165 11.473 7.90827 17.0225 8.13357 25.7855C8.14807 26.3573 7.37862 26.5576 7.10852 26.0529C4.90822 21.9435 4.64076 17.506 5.54459 14.6707C6.50509 12.0237 5.74091 10.9987 4.73826 9.82473C4.231 8.97887 6.79626 7.65737 10.8648 7.25683Z"
          fill="#37DBFF"
        />
        <path
          id="Vector_3"
          d="M20.3788 16.8301C19.9006 16.203 19.1746 15.7603 18.305 15.6694C16.9295 15.5244 15.5988 16.3769 15.1587 17.6892C14.8847 18.5047 14.9769 19.3335 15.3313 20.0212C15.5224 20.3928 16.0454 20.4099 16.2721 20.0581C17.1074 18.7643 18.4803 17.896 20.0113 17.6971C20.4263 17.643 20.6345 17.1621 20.3802 16.8301H20.3788Z"
          fill="#005AFF"
        />
      </g>
    </svg>
  )
}
export const Logo = (props: {
  className?: string
  enClassName?: string
  cnClassName?: string
  onClick?: () => void
  chatType?: FeChatType
}) => {
  const { i18n } = useTranslation()
  if (props.chatType === FeChatType.Agent) {
    return (
      <AgentStudioLogo
        width={110}
        height={16}
        className={props.className}
        onClick={props.onClick}
      />
    )
  }
  return i18n.language === 'zh' && !overseas ? (
    <LogoCN
      className={cn(props.className, props.cnClassName)}
      onClick={props.onClick}
    />
  ) : (
    <LogoEN
      className={cn(props.className, props.enClassName)}
      onClick={props.onClick}
    />
  )
}

export default Logo
